import { BlankV2Plugin } from '../plugins-common/BlankV2/BlankV2Plugin';
import { CorrectAnswersPlugin } from '../plugins-common/CorrectAnswers/CorrectAnswersPlugin';
import { ExplanationsPlugin } from '../plugins-common/Explanations/ExplanationsPlugin';
import { ImageTogglePlugin } from '../plugins-common/ImageToggle/ImageTogglePlugin';
import { ParagraphTogglePlugin } from '../plugins-common/ParagraphToggle/ParagraphTogglePlugin';
import { QuestionStarterPlugin } from '../plugins-common/QuestionStarter/QuestionStarterPlugin';
import { ExerciseGapFillWithHintPlugin } from '../plugins/ExerciseGapFillWithHint/ExerciseGapFillWithHintPlugin';
import { ExerciseMultipleChoicePlugin } from '../plugins/ExerciseMultipleChoice/ExerciseMultipleChoicePlugin';
import { FaqPlugin } from '../plugins/FAQ/FaqPlugin';
import { ExerciseShortAnswerPlugin } from '../plugins/ExerciseShortAnswer/ExerciseShortAnswerPlugin';
import { ExerciseGapFillPlugin } from '../plugins/GapFill/ExerciseGapFillPlugin';
import { ExerciseQuizPlugin } from '../plugins/ExerciseQuiz/ExerciseQuizPlugin';

export const getAllExercisePlugins = ({ isReadOnly, onBackWhenInComplete }) => [
  // exercise
  BlankV2Plugin({ isReadOnly }),
  CorrectAnswersPlugin({ isReadOnly }),
  ExerciseMultipleChoicePlugin({ isReadOnly, onBackWhenInComplete }),
  ExerciseGapFillPlugin({ isReadOnly, onBackWhenInComplete }),
  ExerciseShortAnswerPlugin({ isReadOnly, onBackWhenInComplete }),
  ExplanationsPlugin({ isReadOnly }),
  ImageTogglePlugin({ isReadOnly }),
  ParagraphTogglePlugin({ isReadOnly }),
  QuestionStarterPlugin({ isReadOnly }),
  ExerciseGapFillWithHintPlugin({ isReadOnly, onBackWhenInComplete }),
  FaqPlugin({ isReadOnly }),
  ExerciseQuizPlugin({ isReadOnly }),
];
